import styled from "styled-components";

export const SMoneyAdornment = styled.div`
  && {
    margin: 0;
    padding: 0;
    padding-right: 5px;
    color: ${({ theme }) => theme.colors.textDark};
    font-family: Open Sans;
    font-weight: 600;
    font-size: 12px;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;
